import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SystemCommonModule } from '../system-common/system-common.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { GamificationRoutingModule } from './gamification-routing.module';
import { GamificationService } from './services/gamification.service';
import { FormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { NgSelectModule } from '@ng-select/ng-select';
import { GamificationRequestComponent } from './gamification-request/gamification-request.component';
import { GamificationInquiryComponent } from './gamification-inquiry/gamification-inquiry.component';
import { GamificationResultComponent } from './gamification-result/gamification-result.component';

@NgModule({
  declarations: [GamificationRequestComponent, GamificationInquiryComponent, GamificationResultComponent],
  imports: [
    CommonModule,
    SystemCommonModule,
    FormsModule,
    NgSelectModule,
    DataTablesModule,
    GamificationRoutingModule,
    ModalModule.forChild(),
  ],
  providers: [GamificationService],
})
export class GamificationModule {}
